import { createProductFeaturesQuery, createWithProductFeatures } from './components';
import { createProductFeaturesHook } from './hooks';
import type { Scope } from './types';

export const createFeatureScope = <S extends {}>(scope: Scope<S>) => ({
  ProductFeaturesQuery: createProductFeaturesQuery(scope),
  withProductFeatures: createWithProductFeatures(scope),
  useProductFeatures: createProductFeaturesHook(scope),
});
